import React, { type ComponentProps } from 'react';

import { Button } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const PartnerLineItemHeroButton = (props: Props) => {
  return <Button {...props} size="large-wide" />;
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = Omit<ComponentProps<typeof Button>, 'size'>;
